module.exports = __webpack_public_path__ + "static/media/share_instagram.45c81201.svg";